/* RB chat placement (Oct 21, 2026, sprint 2, audit F3). Loaded on every page from layout/rb.liquid (defer).
   The Shopify Inbox bubble (<shopify-chat>, bottom right, icon only) covered about 75% of the homepage hero's main
   button "לבגדי התינוק", so a tap on the button opened the chat instead, and it sat over the open menu. This file
   only sets two classes on <html>; the CSS that hides the bubble for them is in assets/rb-home.css:
   - rb-chat-defer: while the homepage hero (.rb-hb, sections/rb-hero-baby) is on screen. The hero's own inline
     script sets it before the first paint (so the bubble never flashes over the button while the chat loads);
     here an IntersectionObserver keeps it current: once the hero has scrolled away, the chat shows. It is never set
     again after the visitor has used the chat on this page, so scrolling back up can't hide an open conversation.
     Without IntersectionObserver (very old browsers) it is simply taken off.
   - rb-menu-open: while Dawn's header menu drawer is open (header-drawer > details#Details-menu-drawer-container,
     snippets/header-drawer.liquid). Dawn toggles the details' [open] attribute (global.js, HeaderDrawer: open on the
     summary click, removed 400ms after closing starts, when the slide-out ends), which fires a "toggle" event; it
     doesn't bubble, so it is caught on the way down (capture), which also covers a header re-rendered by the editor.
   Not here: rb-gift-tab-on (the sign-up pop-up section sets it) and rb-sticky-on (product page sticky bar).
   No animation, nothing to stop for reduced motion. Everything is in try/catch: the page works without it. */
(function () {
  if (window.__rbChat) return;
  window.__rbChat = true;   // also read by the hero's inline script: without it, rb-chat-defer comes off after 10 s
  var html = document.documentElement;

  /* ---------- header menu drawer ---------- */
  var MENU = 'details.menu-drawer-container, #Details-menu-drawer-container';
  function syncMenu() {
    try {
      var open = false;
      document.querySelectorAll(MENU).forEach(function (d) { if (d.hasAttribute('open')) open = true; });
      html.classList.toggle('rb-menu-open', open);
    } catch (e) {}
  }
  document.addEventListener('toggle', function (e) {
    var t = e.target;
    if (t && t.matches && t.matches(MENU)) syncMenu();
  }, true);
  // back/forward cache: the page can come back with the drawer still open or already closed
  window.addEventListener('pageshow', syncMenu);
  syncMenu();

  /* ---------- homepage hero ---------- */
  var used = false;     // the visitor has opened or typed in the chat on this page
  var seen = [];        // heroes currently on screen
  var io = null;

  function syncHero() {
    html.classList.toggle('rb-chat-defer', !used && seen.length > 0);
  }
  function watch(scope) {
    var heroes = (scope || document).querySelectorAll('.rb-hb');
    if (!heroes.length) { if (!scope) syncHero(); return; }
    if (!io) { seen = []; syncHero(); return; }
    heroes.forEach(function (h) { io.observe(h); });
  }

  try {
    if ('IntersectionObserver' in window) {
      io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          var i = seen.indexOf(en.target);
          if (en.isIntersecting && i < 0) seen.push(en.target);
          if (!en.isIntersecting && i >= 0) seen.splice(i, 1);
        });
        // a hero removed from the page (theme editor) no longer counts
        seen = seen.filter(function (h) { return h.isConnected; });
        syncHero();
      });
    }
    watch();
  } catch (e) {
    html.classList.remove('rb-chat-defer');
  }

  // A click on the bubble (tap, mouse, or Enter/Space on it) is retargeted to the <shopify-chat> host, its UI being
  // in a shadow root: from then on the chat is in use and must stay put.
  document.addEventListener('click', function (e) {
    if (used || !e.target || !e.target.closest || !e.target.closest('shopify-chat')) return;
    used = true;
    syncHero();
  }, true);

  // theme editor: sections are re-rendered in place
  document.addEventListener('shopify:section:load', function (e) {
    try { watch(e.target); syncMenu(); } catch (err) {}
  });
  document.addEventListener('shopify:section:unload', function () {
    setTimeout(function () { seen = seen.filter(function (h) { return h.isConnected; }); syncHero(); }, 0);
  });
})();
